import React, {Component} from 'react';
import EditableTable from "@components/Table/EditableTable";

import _ from "lodash";
import actions from "@redux/workorder/actions";
import {connect} from "react-redux";
import {api} from "@redux/api";

import { Col, Collapse, Divider, Drawer, Input, Row } from "antd";
import {WidgetWrapper} from "@components/WidgetBox/Widgets.styles";
import SearchLookup from "@components/SearchLookup";
import moment from "moment/moment";
import PermissionControl from "@components/Permission/Permission";
import ColumnChart from "@containers/UtilityData/Charts/ColumnChart";
import queryString from 'query-string';
import {withRouter} from "@/router/withRouter";
import globalMessage from "@/utils/globalMessage";
import {
    RelatedWorkorderColumns,
    RelatedWorkorderProps
} from "@containers/facility/Equipment/RelatedWorkorder/RelatedWorkorderColumns";
import {RelatedWorkorderFormFields} from "@containers/facility/Equipment/RelatedWorkorder/RelatedWorkorderFormFields";
import {RelatedWorkorderComment} from "@containers/facility/Equipment/RelatedWorkorder/RelatedWorkorderComment";
import Detail from "@components/Table/Detail";
import DatePicker from "@components/ResponsiveDatePicker";
import Select from "@components/ResponsiveSelect";
import WorkorderNotification from "@containers/facility/Workorder/WorkorderNotification";
import {
    WORKORDER_PRIORITY_THEME,
    WORKORDER_STATUS_THEME,
} from "@containers/facility/Workorder/WorkorderColumns";
import {useSmartNavigate} from "@/hooks/use-smart-navigate";
import {
    formatWorkOrderStatus,
    getWorkOrderDomainValues,
    getWorkOrderStatusValues,
    loadSemanticCapabilities,
} from "@/services/semanticCapabilities";

const {Option} = Select;

const RELATED_WORKORDER_MOBILE_EXCLUDE_KEYS = [
    "equipment",
    "equipment_name.name",
    "status",
    "priority",
    "energy_impact",
    "Comments",
    "id",
    "modified_date",
];

const RELATED_WORKORDER_MOBILE_INCLUDE_KEYS = [
    "description",
    "responsible_party",
    "assignTo_name",
    "complete_date",
    "reportDate",
    "due_date",
    "recommended_action",
    "workordernumber",
    "project",
    "reportBy",
    "created_date",
    "createdby_name",
    "lastModified_name",
];

const formatMobileModifyDate = (value) => {
    if (value == null || value === "") return "-";
    const date = moment(value);
    return date.isValid() ? date.format("YYYY-MM-DD HH:mm") : "-";
};

const renderMobileMeta = (label, value, className = "", valueStyle = {}) => (
    <span className={`workorder-mobile-card-meta ${className}`.trim()}>
        <span className="workorder-mobile-card-meta-label">{label}: </span>
        <span className="workorder-mobile-card-meta-value" style={valueStyle}>
            {value || "-"}
        </span>
    </span>
);

const getEquipmentName = (record) => {
    if (typeof record.equipment_name === "string") return record.equipment_name;
    return _.get(record, "equipment_name.name") || "-";
};

const renderRelatedWorkorderMobileHeader = (record, navigateToWorkorderDetail) => {
    const equipment = getEquipmentName(record);
    const modifyDate = formatMobileModifyDate(record.modified_date);
    const statusTheme = WORKORDER_STATUS_THEME[record.status];
    const priorityTheme = WORKORDER_PRIORITY_THEME[record.priority];

    const handleTitleClick = (event) => {
        event.stopPropagation();
        navigateToWorkorderDetail(record.id);
    };

    return (
        <div className="workorder-mobile-card">
            <div className="workorder-mobile-card-main">
                <span
                    className="workorder-mobile-card-title workorder-mobile-card-title-link"
                    title={record.issue || ""}
                    onClick={handleTitleClick}
                >
                    {record.issue || "-"}
                </span>
            </div>

            <div className="workorder-mobile-card-details">
                <span className="workorder-mobile-card-equipment" title={equipment}>
                    {equipment}
                </span>

                <div className="workorder-mobile-card-middle">
                    {renderMobileMeta(
                        "Status",
                        record.status,
                        "workorder-mobile-card-meta-status",
                        statusTheme ? {color: statusTheme.color} : {}
                    )}
                    {renderMobileMeta(
                        "Priority",
                        record.priority,
                        "workorder-mobile-card-meta-priority",
                        priorityTheme ? {color: priorityTheme.color} : {}
                    )}
                </div>

                <div className="workorder-mobile-card-end">
                    <div className="workorder-mobile-card-end-top">
                        <span className="workorder-mobile-card-date">{modifyDate}</span>
                        <span
                            className="workorder-mobile-card-chat"
                            onClick={(event) => event.stopPropagation()}
                        >
                            <WorkorderNotification record={record}/>
                        </span>
                    </div>
                    {renderMobileMeta(
                        "Energy Impact",
                        record.energy_impact,
                        "workorder-mobile-card-meta-energy"
                    )}
                </div>
            </div>
        </div>
    );
};

class RelatedWorkorder extends Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();
        this.columns = RelatedWorkorderColumns();
        this.formFields = RelatedWorkorderFormFields(this.tableRef);
        this._drawerFormFieldsRefKey = undefined;
        this._drawerFormFields = RelatedWorkorderFormFields(this.tableRef);
        this.defaultDisplayColumns = {
            "reportDate": {
                "show": false
            },
            "created_date": {
                "show": false
            },
            "complete_date": {
                "show": false
            },
            "reportBy": {
                "show": false
            },
            "project": {
                "show": false
            },
        };
        this.state = {
            columnsStateMap: {},
            data: [],
            status: null,
            statusOptions: getWorkOrderStatusValues(),
            priorityOptions: getWorkOrderDomainValues("priority"),
            energyImpactOptions: getWorkOrderDomainValues("energy_impact"),
            energy: null,
            equipment: null,
            project: null,
            project_name: null,
            equipment_name: null,
            priority: null,
            isLoading: false,
            issue_keyword: null,
            query: null,
            completeYear: null,
            completeMonth: null,
            recordYear: null,
            recordMonth: null,
            groupedStatusData: [],
            groupedPriorityData: [],
            groupedMonthlyData: [],
            panel: null,
            complete_date: [null, null],
            created_date: [null, null],
            report_date: [null, null],
            project_keyword: null,
            equipment_keyword: null,
            issue: null,
            tableRef: null,
            isOpen: false,
            selected_id: null
        }
    }

    componentDidMount() {
        const params = queryString.parse(this.props.location.search);
        if (params?.status) {
            this.setState({
                status: params.status
            })
        }
        if (params?.priority) {
            this.setState({
                priority: params.priority
            })
        }
        if (params?.complete_date) {
            this.setState({
                complete_date: [moment().subtract(params?.complete_date, 'days'), moment()]
            })
        }
        if (params?.report_date) {
            this.setState({
                report_date: [moment().subtract(params?.report_date, 'days'), moment()]
            })
        }
        if (params.created_date) {
            this.setState({
                created_date: [moment().subtract(params?.created_date, 'days'), moment()]
            })
        }
        loadSemanticCapabilities().then((capabilities) => {
            const statusOptions = getWorkOrderStatusValues(capabilities);
            const priorityOptions = getWorkOrderDomainValues("priority", capabilities);
            const energyImpactOptions = getWorkOrderDomainValues("energy_impact", capabilities);
            if (
                _.isEqual(statusOptions, this.state.statusOptions) &&
                _.isEqual(priorityOptions, this.state.priorityOptions) &&
                _.isEqual(energyImpactOptions, this.state.energyImpactOptions)
            ) return;
            this.columns = RelatedWorkorderColumns();
            this.formFields = RelatedWorkorderFormFields(this.tableRef);
            this._drawerFormFields = RelatedWorkorderFormFields(this.tableRef);
            this.setState({statusOptions, priorityOptions, energyImpactOptions});
        });
    }

    getAllWorkOrders = (query) => {
        return api.allworkorderview(query).then(
            response => {
                let dataSource = response.data
                this.setState({
                    groupedMonthlyData: dataSource?.sorted_monthly_data
                });
            }
        ).catch(error => (
            error
        ));
    }

    handleCreateWorkorder = (body) => {
        // console.log('created', this.props.parentProject)

        body['project'] = this.props.SelectedProject;

        let parent = this.props.relatedList;
        if (parent) {
            body['priority'] = 'Urgent';
            body['project'] = this.props.parentProject;
            body['equipment'] = this.props.parentEquipment;
        }

        return api.createWorkorder(body).then(
            response => {
                // console.log('create', response);
                return response.data
            }
        ).catch(error => (
            error
        ));
    }

    handleDeleteWorkorder = (id) => {
        return api.deleteWorkorder(id).then(
            response => {
                return response.data
            }
        ).catch(error => (
            error
        ));
    }

    handleBulkInsert = (body) => {
        return api.bulkWorkorderInsert(body).then(
            response => {
                return response.data
            }
        ).catch(error => {
            return (
                error
            )
        });
    }

    handleBulkDelete = (body) => {
        const validRows = (body || []).filter((r) => r && !r._isWrapperRow);
        if (!validRows.length) {
            return Promise.resolve({ code: 200 });
        }
        return api.bulkDeleteWorkorder(validRows).then(
            response => {
                return response.data
            }
        ).catch(error => (
            error
        ));
    }

    handOnlineSave = (key, row) => {
        row['project'] = this.props.SelectedProject;

        let parent = this.props.relatedList;
        if (parent) {
            row['priority'] = 'Urgent';
            row['project'] = this.props.parentProject;
        }
        return api.editWorkorder(key, row).then(
            response => {
                this.handleDetailDrawer(false, null)
                return response
            }
        ).catch(error => (
            error
        ));
    }

    handleFilter = (query) => {
        this.setState({
            isLoading: true,
        });

        let query_new = query +
            (this.state.issue ? ('&issue=' + (this.state.issue)) : '') +
            (this.state.equipment_name ? ('&equipment_name=' + (this.state.equipment_name)) : '') +
            (this.state.project_name ? ('&project_name=' + (this.state.project_name)) : '') +
            (this.state.status ? ('&status=' + (this.state.status)) : '') +
            (this.state.priority ? ('&priority=' + (this.state.priority)) : '') +
            (this.state.energy ? ('&energy_impact=' + (this.state.energy)) : '') +
            (this.state.complete_date[0] ? ('&complete_date_start=' + (moment(this.state.complete_date[0]).format('YYYY-MM-DD'))) : '') +
            (this.state.complete_date[1] ? ('&complete_date_end=' + (moment(this.state.complete_date[1]).format('YYYY-MM-DD'))) : '') +
            (this.state.report_date[0] ? ('&report_date_start=' + (moment(this.state.report_date[0]).format('YYYY-MM-DD'))) : '') +
            (this.state.report_date[1] ? ('&report_date_end=' + (moment(this.state.report_date[1]).format('YYYY-MM-DD'))) : '') +
            (this.state.created_date[0] ? ('&created_date_start=' + (moment(this.state.created_date[0]).format('YYYY-MM-DD'))) : '') +
            (this.state.created_date[1] ? ('&created_date_end=' + (moment(this.state.created_date[1]).format('YYYY-MM-DD'))) : '')
        ;
        let parent = this.props.relatedList;
        if (parent) {
            if (this.props.parentProject) {
                query_new += '&project=' + this.props.parentProject + '&';
            }
            if (this.props.parentEquipment) {
                query_new += '&equipment=' + this.props.parentEquipment + '&';
            }
        }
        return api.filterWorkorder(query_new).then(
            response => {
                let dataSource = response.data.results
                return {
                    data: dataSource,
                    success: true,
                    total: response.data.count
                }
            }
        ).catch(error => {
            console.error(error);
            const desc = _.get(error, "response.data.detail") ||
                _.get(error, "response.data.message") ||
                _.get(error, "message", "Failed to load work orders");
            globalMessage.error({
                message: "Error",
                description: typeof desc === "string" ? desc : "Failed to load work orders",
            });
            this.setState({ isLoading: false });
            return { data: [], success: false, total: 0 };
        });
    }

    getWorkorder = (data) => {

        this.setState({
            data,
            isLoading: false,
        });
        // this.props.setWorkorderSuccess(data)
    };

    handleFormRelated = (e) => {
        console.log('handleFormRelated', e);
    }

    handleClearButtonClick = (e) => {
        this.setState({
            status: null,
            priority: null,
            energy_impact: null,
            equipment: null,
            project: null,
            query: null,
        }, function () {
            this.refresh(false)
        })
    }

    setFilters = () => {
    };

    resetFilters = () => {
        this.setState({
            status: null,
            priority: null,
            energy: null,
            equipment: null,
            project: null,
            project_name: null,
            equipment_name: null,
            issue: null,
            issue_keyword: null,
            equipment_keyword: null,
            project_keyword: null,
            complete_date: [null, null],
            created_date: [null, null],
            report_date: [null, null],
            query: null,
        }, () => this.refresh(false));
    };
    handlePostComment = (e) => {
        return <RelatedWorkorderComment id={e}/>
    }

    refresh = (needRequest) => {

        return this.tableRef?.current?.refresh(needRequest);
    };

    handleLookupFilter = (e) => {
        console.log('test')
        let query_new = (this.state.issue_keyword ? ('issue=' + this.state.issue_keyword) : '') +
            (this.state.equipment_keyword ? ('equipment_name=' + this.state.equipment_keyword) : '') +
            (this.state.project_keyword ? ('project_name=' + this.state.project_keyword) : '') +
            '&limit=15';

        return api
            .filterWorkorder(query_new)
            .then((response) => {
                let dataSource = response.data.results;
                return {
                    data: dataSource,
                    success: true,
                    total: response.data.count,
                };
            })
            .catch((error) => {
                return error;
            });
    }

    handleSelect = (e, type) => {
        this.setState({
            [type]: e,
            limit: null
        }, function () {
            this.refresh(false);
        })
    }

    handleSearchSelect = (e, type) => {
        this.setState({
            [type]: e,
            limit: null
        }, function () {
            this.refresh(false);
        })
    }

    handleSearch = (e, type) => {
        this.setState({
            [type + '_keyword']: e
        });
        return this.handleLookupFilter();
    }

    onDateChange = (dates, state, index) => {
        let bDate = this.state[state];
        bDate[index] = dates

        this.setState({
            [state]: bDate
        }, function () {
            this.refresh(false);
        })

    }

    renderSearches = () => {
        return (
            <>
                <SearchLookup
                    placeholder={'issue'}
                    name={'issue'}
                    style={{width: '18rem', paddingRight: '1rem'}}
                    SelectedLookup_CommonRequest={(e) => this.handleSearchSelect(e, 'issue')}
                    Lookup_CommonupRequest={(e) => this.handleSearch(e, 'issue')}
                />
                <SearchLookup
                    placeholder={'Equipment'}
                    name={'equipment_search_name'}
                    style={{width: '15rem', paddingRight: '1rem'}}
                    SelectedLookup_CommonRequest={(e) => this.handleSearchSelect(e, 'equipment_name')}
                    Lookup_CommonupRequest={(e) => this.handleSearch(e, 'equipment')}
                />
                <SearchLookup
                    placeholder={'Project'}
                    name={'project_search_name'}
                    style={{width: '15rem', paddingRight: '1rem'}}
                    SelectedLookup_CommonRequest={(e) => this.handleSearchSelect(e, 'project_name')}
                    Lookup_CommonupRequest={(e) => this.handleSearch(e, 'project')}
                />
                <SearchLookup
                    placeholder={'WO #'}
                    name={'workordernumber'}
                    style={{width: '15rem', paddingRight: '1rem'}}
                    SelectedLookup_CommonRequest={(e) => this.handleSearchSelect(e, 'workordernumber')}
                    Lookup_CommonupRequest={(e) => this.handleSearch(e, 'workordernumber')}
                />

                <div className={'pr-3'}>
                    <Select placeholder={'Status'} mode="multiple" className={'min-multi-selector'}
                            value={this.state.status}
                            onChange={(e) => this.handleSearchSelect(e, 'status')}>

                        <Option value=""></Option>
                        {this.state.statusOptions.map((status) => (
                            <Option key={status} value={status}>
                                {formatWorkOrderStatus(status)}
                            </Option>
                        ))}
                    </Select>
                </div>

                <div className={'pr-3'}>
                    <Select style={{width: '10rem'}} className={'mr-3'} placeholder={'Priority'}
                            value={this.state.priority}
                            onChange={(e) => this.handleSearchSelect(e, 'priority')}>
                        <Option value=""></Option>
                        {this.state.priorityOptions.map((value) => (
                            <Option key={value} value={value}>{value}</Option>
                        ))}
                    </Select>
                </div>

                <div className={'pr-3'}>
                    <Select style={{width: '10rem'}} className={'mr-3'} placeholder={'Energy'}
                            onChange={(e) => this.handleSearchSelect(e, 'energy')}>
                        <Option value=""></Option>
                        {this.state.energyImpactOptions.map((value) => (
                            <Option key={value} value={value}>{value}</Option>
                        ))}
                    </Select>
                </div>

                <div className={'flex flex-wrap items-center'}>
                    <DatePicker
                        className={'border-right-6'}
                        value={this.state.complete_date[0]}
                        placeholder={'complete start'}
                        style={{width: '15rem'}}
                        onChange={(dates) => this.onDateChange(dates, 'complete_date', 0, '')}
                    />
                    <DatePicker
                        className={'border-left-6'}
                        value={this.state.complete_date[1]}
                        placeholder={'complete end'}
                        style={{width: '15rem'}}
                        onChange={(dates) => this.onDateChange(dates, 'complete_date', 1, '')}
                    />
                </div>

                <div className={'flex flex-wrap items-center'}>
                    <DatePicker
                        className={'border-right-6'}
                        value={this.state.report_date[0]}
                        placeholder={'report start'}
                        style={{width: '15rem'}}
                        onChange={(dates) => this.onDateChange(dates, 'report_date', 0, '')}
                    />
                    <DatePicker
                        className={'border-left-6'}
                        value={this.state.report_date[1]}
                        placeholder={'report end'}
                        style={{width: '15rem'}}
                        onChange={(dates) => this.onDateChange(dates, 'report_date', 1, '')}
                    />
                </div>

                <div className={'flex flex-wrap items-center'}>
                    <DatePicker
                        className={'border-right-6'}
                        value={this.state.created_date[0]}
                        placeholder={'created start'}
                        style={{width: '15rem'}}
                        onChange={(dates) => this.onDateChange(dates, 'created_date', 0, '')}
                    />
                    <DatePicker
                        className={'border-left-6'}
                        value={this.state.created_date[1]}
                        placeholder={'created end'}
                        style={{width: '15rem'}}
                        onChange={(dates) => this.onDateChange(dates, 'created_date', 1, '')}
                    />
                </div>

            </>
        )
    }

    handlePanelChange = (e) => {
        console.log('handlePanelChange', e)
        this.setState({
            panel: e[0]
        }, function () {
            if (e[0]) {
                // this.refresh(false)
                this.getAllWorkOrders()
            }
        })
    }

    gettableRef = (tableRef) => {
        this.setState({
            tableRef
        })
    }

    renderDrawer = (isOpen, selected_id) => {
        console.log('renderDrawer', isOpen, selected_id)
        const drawerRef = this.state.tableRef || this.tableRef;
        if (this._drawerFormFieldsRefKey !== drawerRef) {
            this._drawerFormFieldsRefKey = drawerRef;
            this._drawerFormFields = RelatedWorkorderFormFields(drawerRef);
        }
        const drawerKey = 'RelatedWorker_drawer'+selected_id;
        return <Drawer
            key={drawerKey}
            width={window.innerWidth > 900 ? '80%' : '100%'}
            placement="right"
            closable={false}
            onClose={() => this.handleDetailDrawer(false, null)}
            visible={isOpen}
            destroyOnClose={true}
            autoFocus={true}
        >
            <div>
                {isOpen ?
                    <Detail
                        key={'tablecontent_detail'}
                        formKey={'tablecontent_detail'}
                        formFields={this._drawerFormFields}
                        handOnlineSave={this.handOnlineSave}
                        createRecords={this.createRecords}
                        handleSaveComment={this.handleSaveComment}
                        onClose={() => {this.handleDetailDrawer(false, null)}}
                        handleDelete={this.deleteRecord}
                        columnProps={this.props.columnProps}
                        isAttachments={this.props.isAttachments}
                        formRefCallback={this.formRefCallback}
                        data={this.state.data.filter(e => e.id === selected_id)[0]}/> : ''}
            </div>
        </Drawer>
    }

    handleDetailDrawer = (e, selected_id) => {
        this.setState({
            isOpen: e,
            selected_id: selected_id
        })
    }
    render() {

        return (

            <div className="">

                <EditableTable
                    ref={this.tableRef}
                    columns={this.columns}
                    data={this.state.data}
                    columnProps={RelatedWorkorderProps}
                    formFields={this.formFields}
                    formRelated={this.handleFormRelated}
                    postComment={this.handlePostComment}
                    getRecord={this.getWorkorder}
                    createRecords={this.handleCreateWorkorder}
                    deleteRecord={this.handleDeleteWorkorder}
                    bulkInsert={this.handleBulkInsert}
                    bulkDelete={this.handleBulkDelete}
                    handOnlineSave={this.handOnlineSave}
                    handleFilter={this.handleFilter}
                    // renderFilter={this.renderFilter}
                    relatedList={this.props.relatedList}
                    relatedId={this.props.relatedId}
                    relatedObject={this.props.relatedObject}
                    hide_search={true}
                    isRowClickable={false}
                    isChat={true}
                    isRelated={false}
                    isAttachments={true}
                    setFilters={this.setFilters}
                    resetFilters={this.resetFilters}
                    getFormRef={this.gettableRef}
                    renderSearches={this.renderSearches}
                    defaultDisplayColumns={this.defaultDisplayColumns}
                    hideMobileTableExpand={true}
                    hideMobileColumnActions={true}
                    mobileCardHeaderRender={(record) => renderRelatedWorkorderMobileHeader(
                        record,
                        this.props.navigateToWorkorderDetail
                    )}
                    mobileExpandedExcludeKeys={RELATED_WORKORDER_MOBILE_EXCLUDE_KEYS}
                    mobileExpandedIncludeKeys={RELATED_WORKORDER_MOBILE_INCLUDE_KEYS}
                />

                {this.renderDrawer(this.state.isOpen, this.state.selected_id)}

            </div>

        );
    }
}

const mapStateToProps = state => {
    return {
        Workorder: _.get(state.Workorder, 'data'),
        SelectedEquipment: _.get(state.Equipment, 'selectedEquipment.id'),
        SelectedProject: _.get(state.Project, 'selectedProject.id'),
    }
}
const mapDispatchToProps = dispatch => {
    return {

        setWorkorderRequest: (e) => dispatch(actions.WorkorderRequest(e)),
        setWorkorderSuccess: (e) => dispatch(actions.WorkorderSuccess(e)),
    }
}

const withHooks = (Component) => {
    const NewComponent = (props) => {
        const {navigateToWorkorderDetail} = useSmartNavigate();
        return (
            <Component
                {...props}
                navigateToWorkorderDetail={navigateToWorkorderDetail}
            />
        );
    };
    return NewComponent;
};

export default withHooks(withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(RelatedWorkorder)));
